import { VBox } from "@/components-v2/Box";
import { Button } from "@/components-v2/Button";
import { FC } from "react";
import { observer } from "mobx-react";
import { EmptyState } from "@/components-v2/EmptyState";
import DefaultLayout from "@/containers/DefaultLayout";
import { useDispatch, useTranslation } from "@/stores/RootStoreContext";
import { navigate } from "@/events/eventsDomain";
import { adminSettingsBilling } from "@/utils/navigation";

export const OrderSubscriptionUpgrade: FC<{
  orgNo: string;
}> = observer(({ orgNo }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  return (
    <DefaultLayout>
      <VBox grow={"golden"} justifyContent={"center"} marginTop>
        <EmptyState
          illustration={"sparkle"}
          title={t("subscription.moduleNotIncluded.title")}
          description={<p>{t("subscription.moduleNotIncluded.description")}</p>}
          actions={
            <Button
              variant={"primary"}
              label={t("subscription.moduleNotIncluded.enableButton")}
              onClick={() => dispatch([navigate(adminSettingsBilling(orgNo))])}
            />
          }
        />
      </VBox>
    </DefaultLayout>
  );
});
